import { LOB } from './plans';

export enum MARKETPLACE {
    ON = 'onExchange',
    OFF = 'offExchange',
}
export interface Filters {
    marketplace: MARKETPLACE | null;
    productType: LOB[];
    metallicLevel: ('Gold' | 'Silver' | 'Bronze')[];
    easyPricing: boolean;
    // topPick: boolean;
}

export enum SORT {
    // NONE = '',
    LOW_TO_HIGH = 'Price (Low to High)',
    HIGH_TO_LOW = 'Price (High to Low)',
    NETWORK = 'Network',
    METALLIC = 'Metallic Level',
}
